<template>
	<div>
		<div class="ask2">
			<div class="ask2-title">
				<input type="text" class="ask2-title-input" placeholder="请输入您的问题" v-model="questionTitle"/>
			</div>
			<div class="ask2-content">
				<textarea class="ask2-content-area" placeholder="正文" v-model="questionContent"></textarea>
			</div>
			<div class="ask-button">
				<button type="button" @click="submitQuestion()">发送</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				questionTitle:"",
				questionContent:""
			}
		},
		methods:{
			submitQuestion(){
				this.$api.get("",{
					api:"/v1/question_answer/create_question",
					title:this.questionTitle,
					content:this.questionContent,
					course_id:this.$route.params.courseId,
					section_id:this.$route.params.id,
					user_type:this.tools.getStorage("user_type")
				},res => {
				  if(res.status==1){
            this.$toast("添加成功！");
            this.questionTitle="";
            this.questionContent="";
            this.$router.push("/lesson-question/"+this.$route.params.courseId+"/"+this.$route.params.id);
          }else{
            this.$toast(res.msg);
          }
				},res => {
					this.$toast(res.msg);
				})
			}
		}
	}
</script>

<style>
	.ask2{
		padding-top:0.32rem;
	}
	.ask2-title{
		margin:0 0.4rem;
		height:0.826rem;
		border-bottom:1px solid #cccccc;
	}
	.ask2-title-input{
		width:100%;
		height:100%;
		border:0;
		font-size: 0.426rem;
		color:#333;
		background:#f2f2f2;
	}
	.ask2-content-area{
		width:9.2rem;
		height:5.333rem;
		padding:0.4rem;
		border:0;
		font-size: 0.426rem;
		color:#333;
		background:#f2f2f2;
	}
	.ask-button{
		position: absolute;
		bottom:0;
		left:0;
		width:10rem;
		height:1.173rem;
		line-height:1.173rem;
		background: #fff;
		text-align: center;
	}
	.ask-button button{
		width:9.2rem;
		height:0.96rem;
		color:#fff;
		background: #ec6d3a;
		border:0;
		border-radius: 0.133rem;
		font-size: 0.426rem;
		vertical-align: middle;
	}
</style>



// WEBPACK FOOTER //
// src/components/ask/ask.vue